module.exports = __webpack_public_path__ + "img/18@2x.d7149113.png";